/// <amd-module name="Environments/Providers/Kubernetes/AzureDevOpsImageService" />
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Services, VssService, IVssService } from "VSS/Platform/Context";
import { publishEvent } from "VSS/Platform/Telemetry";
import { IImageDetails } from "Types";
import { IDeploymentRestClient, DeploymentClientName } from "Environments/RemoteClients/Deployment";
import { ArtifactProvenance } from "Environments/RemoteClients/Contracts/Deployment";
import { ImageServiceConstants } from "./Constants";

const imageDetailsDataProviderId = "ms.vss-environments-web.image-details-data-provider";
const hasImageDetailsDataProviderId = "ms.vss-environments-web.has-image-details-data-provider";

export interface IImageService extends IVssService {
    hasImageDetails(listImages: Array<string>): Promise<{ [key: string]: boolean } | undefined>;

    getImageDetails(imageName: string): Promise<IImageDetails | undefined>;

    getImageProvenances(imageNames: string[]): Promise<ArtifactProvenance[]>;
}

export class AzureDevOpsImageService extends VssService implements IImageService {
    public hasImageDetails(listImages: Array<string>): Promise<{ [key: string]: boolean } | undefined> {
        const additionalProperties = { imageNames: listImages };
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<{ [key: string]: boolean }>(hasImageDetailsDataProviderId, additionalProperties, true);
    }

    public getImageDetails(imageName: string): Promise<IImageDetails | undefined> {
        const additionalProperties = { imageName: imageName };
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<IImageDetails>(imageDetailsDataProviderId, additionalProperties, true);
    }

    public getImageProvenances(imageNames: string[]): Promise<ArtifactProvenance[]> {
        const deploymentRestClient = this.pageContext.getRestClient<IDeploymentRestClient>(DeploymentClientName);

        publishEvent(this.pageContext, ImageServiceConstants.ImageProvenanceArea, ImageServiceConstants.ImageProvenanceAPIInvokedFeature, {
            [ImageServiceConstants.TelemeterySourceKey]: ImageServiceConstants.K8sSummaryImageServiceSource
        });
        return deploymentRestClient.getArtifactProvenances(imageNames);
    }
}

Services.add("IImageService", { serviceFactory: AzureDevOpsImageService });
